import React from 'react';
import { useNavigate } from 'react-router-dom';

import { PageLayout } from "src/shared/components/layout/PageLayout";
import { Button } from "src/shared/components/ui/Button";
import img404 from 'src/shared/img/404.png';

import styles from './Page404.module.css';

const Page404: React.FC = () => {
    const navigate = useNavigate();

    return (
        <PageLayout className={styles.error}>
            <img className={styles.img} src={img404} alt="Page 404"/>
            <h2>Page not found</h2>
            <p>This page might have moved, been deleted, or perhaps it was never created. But don't worry — it's just a 404 error</p>
            <Button variant={"primary"} onClick={() => navigate('/')}>Go back to the main</Button>
        </PageLayout>
    );
};

export default Page404;
